import Description from "@/partials/elements/Description";
import Headline from "@/partials/elements/Headline";
import React from "react";

export default function CardInfo({ item }) {
  return (
    <div className="*:text-white">
      <Headline text={item?.value} />
      <Description text={item?.title} />
    </div>
  );
}
